import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSuperAdmin } from '../hooks/useSuperAdmin';
import LoadingSpinner from './LoadingSpinner';
import SuperAdminLogin from './SuperAdminLogin';
import { useAuth } from '../hooks/useAuth';

export default function SuperAdminRoute({ children }: { children: React.ReactNode }) {
    const { isSuperAdmin, loading: adminLoading } = useSuperAdmin();
    const { user, loading: authLoading } = useAuth();

    const loading = adminLoading || authLoading;

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    // If not logged in OR logged in but not super admin -> Show Login Gate
    if (!user || !isSuperAdmin) {
        return <SuperAdminLogin />;
    }

    return <>{children}</>;
}
